var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Twitter_2",
    d: "M11.0526 26.6668C21.1156 26.6668 26.6196 18.4585 26.6196 11.3404C26.6196 11.1072 26.6196 10.8751 26.6036 10.6441C27.6743 9.88156 28.5986 8.93741 29.3332 7.85584C28.3347 8.29167 27.2754 8.57736 26.1908 8.70334C27.333 8.03023 28.1878 6.97139 28.5961 5.72396C27.5222 6.35145 26.3472 6.79365 25.122 7.03144C24.2971 6.16786 23.2061 5.59601 22.0178 5.4044C20.8296 5.21279 19.6103 5.41209 18.5487 5.97147C17.4871 6.53084 16.6423 7.41911 16.1451 8.49881C15.6479 9.5785 15.526 10.7894 15.7982 11.9442C13.6231 11.8368 11.4951 11.2802 9.55257 10.3107C7.61001 9.34109 5.89624 7.98018 4.5225 6.31626C3.82287 7.5021 3.60858 8.90588 3.92328 10.2418C4.23798 11.5777 5.05799 12.7453 6.21637 13.5069C5.34565 13.4818 4.49389 13.2505 3.73317 12.8327V12.9009C3.73352 14.1446 4.17078 15.3499 4.9708 16.3123C5.77083 17.2747 6.88435 17.935 8.1225 18.1813C7.31704 18.3976 6.47192 18.4292 5.6521 18.2737C6.00185 19.344 6.68254 20.2798 7.59899 20.9505C8.51545 21.6212 9.62187 21.9932 10.7636 22.0145C9.62921 22.8924 8.33019 23.5414 6.94081 23.9245C5.55143 24.3076 4.09896 24.4173 2.6665 24.2472C5.16854 25.828 8.07975 26.6665 11.0526 26.6626",
    fill: "#252525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.28e0b38db3001e35a039c6d7b644f58d.svg";
export { ForwardRef as ReactComponent };